"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectIsWorkingSelectionEmpty = exports.selectIsWorkingSelectionChanged = exports.selectInvertableCommittedSelection = exports.selectInvertableWorkingSelection = exports.selectIsCommittedSelectionInverted = exports.selectCommittedSelection = exports.selectIsWorkingSelectionInverted = exports.selectWorkingSelection = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var toolkit_1 = require("@reduxjs/toolkit");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var selectors_1 = require("../common/selectors");
/**
 * @internal
 */
exports.selectWorkingSelection = toolkit_1.createSelector(selectors_1.selectState, function (state) { return state.selection.working.keys; });
/**
 * @internal
 */
exports.selectIsWorkingSelectionInverted = toolkit_1.createSelector(selectors_1.selectState, function (state) { return state.selection.working.isInverted; });
/**
 * @internal
 */
exports.selectCommittedSelection = toolkit_1.createSelector(selectors_1.selectState, function (state) { return state.selection.commited.keys; });
/**
 * @internal
 */
exports.selectIsCommittedSelectionInverted = toolkit_1.createSelector(selectors_1.selectState, function (state) { return state.selection.commited.isInverted; });
/**
 * @internal
 */
exports.selectInvertableWorkingSelection = toolkit_1.createSelector(exports.selectWorkingSelection, exports.selectIsWorkingSelectionInverted, function (keys, isInverted) { return ({
    keys: keys,
    isInverted: isInverted,
}); });
/**
 * @internal
 */
exports.selectInvertableCommittedSelection = toolkit_1.createSelector(exports.selectCommittedSelection, exports.selectIsCommittedSelectionInverted, function (keys, isInverted) { return ({
    keys: keys,
    isInverted: isInverted,
}); });
/**
 * @internal
 */
exports.selectIsWorkingSelectionChanged = toolkit_1.createSelector(exports.selectIsWorkingSelectionInverted, exports.selectWorkingSelection, exports.selectIsCommittedSelectionInverted, exports.selectCommittedSelection, function (isWorkingSelectionInverted, workingSelection, isCommitedSelectionInverted, commitedSelection) {
    return isWorkingSelectionInverted !== isCommitedSelectionInverted ||
        !isEqual_1.default(tslib_1.__spreadArrays(commitedSelection).sort(), tslib_1.__spreadArrays(workingSelection).sort());
});
/**
 * @internal
 */
exports.selectIsWorkingSelectionEmpty = toolkit_1.createSelector(exports.selectWorkingSelection, isEmpty_1.default);
//# sourceMappingURL=selectionSelectors.js.map